/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* PatientLabTests service.
* @module api/PatientLabTestsApi
* @version v0.3
*/
export default class PatientLabTestsApi {

    /**
    * Constructs a new PatientLabTestsApi. 
    * @alias module:api/PatientLabTestsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the patientLabTestsGet operation.
     * @callback moduleapi/PatientLabTestsApi~patientLabTestsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all Patient Lab Test
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.byPatientId Filter by patient id
     * @param {Number} opts.page Page number (default to <.>)
     * @param {Number} opts.size Page size (default to <.>)
     * @param {Array.<module:model/String>} opts.sortBy Sort results
     * @param {Array.<String>} opts.byId Filter by id
     * @param {module:api/PatientLabTestsApi~patientLabTestsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientLabTestsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'by_patient_id': this.apiClient.buildCollectionParam(opts['byPatientId'], 'csv'),'page': opts['page'],'size': opts['size'],'sort_by': this.apiClient.buildCollectionParam(opts['sortBy'], 'csv'),'by_id': this.apiClient.buildCollectionParam(opts['byId'], 'csv')
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patient_lab_tests', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientLabTestsIdGet operation.
     * @callback moduleapi/PatientLabTestsApi~patientLabTestsIdGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve a Patient Lab Test
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {String} id 
     * @param {module:api/PatientLabTestsApi~patientLabTestsIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientLabTestsIdGet(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientLabTestsIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patient_lab_tests/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}